(() => {
  const root = document.querySelector(".rr-hdk");
  if (!root || !window.RR_HDK) return;

  const CFG = window.RR_HDK;
  const money = (cents) =>
    (Number(cents) / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });

  const toast = root.querySelector("#toast");
  const sticky = root.querySelector("#stickyAtc");
  const stickyName = root.querySelector("#stickyName");
  const stickyPrice = root.querySelector("#stickyPrice");
  const stickyThumb = root.querySelector("#stickyThumb");
  const stickyBtn = root.querySelector("#stickyAtcBtn");
  const stickyContext = root.querySelector("#stickyContext");
  const pestPacksEl = root.querySelector("#pestPacks");
  const pestSummary = root.querySelector("#pestFilterSummary");
  const builderAtcName = root.querySelector("#builderAtcName");
  const builderAtcPrice = root.querySelector("#builderAtcPrice");
  const builderAtcBtn = root.querySelector("#builderAtcBtn");

  let activeArea = "home";
  let selectedPests = new Set(["rat", "mouse"]);
  let lastKit = null;
  let toastTimer;
  let adding = false;

  function areaKeys() {
    return Object.keys(CFG.areas);
  }

  function kitDiscountRate(pestCount) {
    if (pestCount >= 3) return CFG.discounts?.threePest ?? 0.08;
    if (pestCount >= 2) return CFG.discounts?.twoPest ?? 0.05;
    return 0;
  }

  function kitDiscountCode(pestCount) {
    if (pestCount >= 3) return CFG.discounts?.codeThree || "HDK8";
    if (pestCount >= 2) return CFG.discounts?.codeTwo || "HDK5";
    return null;
  }

  function buildKit(areaId, pestList) {
    const a = CFG.areas[areaId];
    if (!a) return null;
    const pests = pestList.filter((k) => CFG.pests[k]);
    const contents = [];
    const items = [];
    const soldOut = [];
    let retail = 0;
    let thumb = CFG.images.barn;

    pests.forEach((key) => {
      const pest = CFG.pests[key];
      const qty = a.qty[key] || 1;
      contents.push({
        pestKey: key,
        qty,
        shortName: pest.shortName,
        img: pest.img,
        available: pest.available,
      });
      if (pest.available && pest.variantId) {
        items.push({ id: pest.variantId, quantity: qty });
        retail += pest.price * qty;
        if (thumb === CFG.images.barn) thumb = pest.img;
      } else {
        soldOut.push(pest.shortName);
      }
    });

    const rate = kitDiscountRate(pests.length);
    const price = Math.round(retail * (1 - rate));
    const savings = retail - price;

    const labels = pests.map((k) => CFG.pests[k].label);
    const name =
      labels.length === 0
        ? `${a.name} Kit`
        : labels.length <= 2
          ? `${a.name} · ${labels.join(" + ")}`
          : `${a.name} · ${labels.length}-pest kit`;

    return {
      areaId,
      pests,
      name,
      blurb: a.blurb,
      retail,
      price,
      savings,
      discountRate: rate,
      discountCode: kitDiscountCode(pests.length),
      thumb,
      contents,
      items,
      soldOut,
      canAdd: items.length > 0,
    };
  }

  function areaSlug(areaId) {
    return (
      {
        home: "home",
        farmhouse: "farmhouse",
        farm: "farm-barn",
        coop: "chicken-coop",
        shed: "garage-shed",
      }[areaId] || areaId
    );
  }

  function pestSlug(pests) {
    const set = new Set(pests);
    if (set.size === 1 && set.has("rat")) return "rats";
    if (set.size === 1 && set.has("mouse")) return "mice";
    if (set.size === 1 && set.has("squirrel")) return "squirrels";
    if (set.size === 1 && set.has("chipmunk")) return "chipmunks";
    if (set.size === 1 && set.has("skunk")) return "skunks";
    if (set.size === 2 && set.has("rat") && set.has("mouse")) return "rats-mice";
    if (set.size === 3 && set.has("rat") && set.has("mouse") && set.has("squirrel")) {
      return "3-pest-rats-mice-squirrels";
    }
    if (set.size === 3 && set.has("rat") && set.has("mouse") && set.has("skunk")) {
      return "3-pest-rats-mice-skunks-sold-out";
    }
    const names = { rat: "rats", mouse: "mice", squirrel: "squirrels", chipmunk: "chipmunks", skunk: "skunks" };
    return pests.map((p) => names[p] || p).join("-");
  }

  function comboKey(areaId, pests) {
    if (!CFG.areas[areaId] || !pests.length) return "";
    return `${areaSlug(areaId)}-${pestSlug(pests)}`;
  }

  function kitVisualHtml(kit) {
    const key = comboKey(kit.areaId, kit.pests);
    const comboImg = CFG.comboImages && CFG.comboImages[key];
    if (comboImg) {
      const src = comboImg.includes("?") ? `${comboImg}&width=1400` : `${comboImg}?width=1400`;
      return `<div class="pack-card__visual pack-card__visual--photo"><img src="${src}" alt="" width="700" height="700" loading="lazy" /></div>`;
    }

    // Improvised storefront packs (no dedicated area photo yet)
    if (kit.pests.length === 1) {
      const pestKey = kit.pests[0];
      const pest = CFG.pests[pestKey];
      const qty = CFG.areas[kit.areaId].qty[pestKey] || 1;
      const badge =
        qty > 1 ? `<span class="pack-visual__qty-badge" aria-hidden="true">${qty}×</span>` : "";
      return `<div class="pack-card__visual pack-card__visual--photo pack-card__visual--improvised"><img src="${pest.img}" alt="" width="700" height="700" loading="lazy" />${badge}</div>`;
    }

    const groups = kit.pests.map((pestKey) => {
      const pest = CFG.pests[pestKey];
      const qty = CFG.areas[kit.areaId].qty[pestKey] || 1;
      const show = Math.min(qty, 4);
      const imgs = Array.from(
        { length: show },
        () => `<img src="${pest.img}" alt="" width="168" height="168" loading="lazy" />`
      ).join("");
      const more = qty > show ? `<span class="pack-visual__more">×${qty}</span>` : "";
      return `<div class="pack-visual__group">${imgs}${more}</div>`;
    });

    return `<div class="pack-card__visual pack-card__visual--composite pack-card__visual--improvised">${groups.join(
      '<span class="pack-visual__plus" aria-hidden="true">+</span>'
    )}</div>`;
  }

  function cardHtml(kit, { badge, featured } = {}) {
    if (!kit) return "";
    const visual = kitVisualHtml(kit);
    const lines = kit.contents
      .map(
        (c) =>
          `<li><span class="pack-qty">${c.qty}</span><span class="pack-qty-x">×</span> <span class="pack-item-name">${c.shortName}</span></li>`
      )
      .join("");
    const note = "";
    const disabled = kit.canAdd ? "" : " disabled";
    const pestAttr = kit.pests.join(",");
    const savePct = Math.round((kit.discountRate || 0) * 100);
    const badges = [
      badge ? `<span class="pack-card__pill pack-card__pill--accent">${badge}</span>` : "",
      savePct > 0 ? `<span class="pack-card__pill pack-card__pill--save">Save ${savePct}%</span>` : "",
    ]
      .filter(Boolean)
      .join("");
    const priceBlock = !kit.canAdd
      ? `<div class="pack-card__pricing"><p class="pack-card__price">—</p></div>`
      : kit.discountRate > 0
        ? `<div class="pack-card__pricing">
            <p class="pack-card__price">${money(kit.price)}</p>
            <p class="pack-card__compare"><s>${money(kit.retail)}</s></p>
            <p class="pack-card__save-note">You save ${money(kit.savings)}</p>
          </div>`
        : `<div class="pack-card__pricing"><p class="pack-card__price">${money(kit.price)}</p></div>`;

    return `
      <article class="pack-card${featured ? " pack-card--featured" : ""}${kit.discountRate > 0 ? " pack-card--deal" : ""}" data-kit-area="${kit.areaId}" data-kit-pests="${pestAttr}">
        <div class="pack-card__visual-wrap">${visual}</div>
        ${badges ? `<div class="pack-card__pills">${badges}</div>` : ""}
        <h3 class="pack-card__name">${kit.name}</h3>
        <ul class="pack-card__places">${lines}</ul>
        ${note}
        ${priceBlock}
        <button type="button" class="btn ${featured || kit.discountRate > 0 ? "btn--primary" : "btn--ghost"}" data-add-kit data-kit-area="${kit.areaId}" data-kit-pests="${pestAttr}"${disabled}>
          ${kit.canAdd ? "Add this kit to cart" : "Unavailable"}
        </button>
      </article>
    `;
  }

  function kitSize(kit) {
    if (!kit) return 0;
    return kit.contents.reduce((sum, c) => sum + (c.available !== false ? c.qty : 0), 0);
  }

  function sortKitsBiggestFirst(a, b) {
    const sizeDiff = kitSize(b.kit) - kitSize(a.kit);
    if (sizeDiff !== 0) return sizeDiff;
    return (b.kit.retail || b.kit.price || 0) - (a.kit.retail || a.kit.price || 0);
  }

  function getAreaCombos(areaId) {
    const map = CFG.areaCombos;
    if (!map) return [];
    const list = Array.isArray(map) ? map : map[areaId] || [];
    return list.filter((combo) => (combo.pests || []).length >= 2).slice(0, 4);
  }

  function samePestSet(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    const set = new Set(a);
    return b.every((p) => set.has(p));
  }

  function findCatalogCombo(areaId, pests) {
    if (!pests || pests.length < 2) return null;
    return getAreaCombos(areaId).find((combo) => samePestSet(combo.pests, pests)) || null;
  }

  function catalogRowsForPests(pests) {
    if (!pests.length || pests.length < 2) return [];
    return areaKeys()
      .map((areaId) => {
        const combo = findCatalogCombo(areaId, pests);
        if (!combo) return null;
        const kit = buildKit(areaId, combo.pests);
        if (!kit) return null;
        return {
          kit,
          badge: combo.badge || null,
          featured: !!combo.featured,
        };
      })
      .filter(Boolean)
      .slice(0, 4);
  }

  function mobilePerView(el) {
    const raw = el?.dataset?.packPerViewMobile || el?.closest("[data-pack-per-view-mobile], [data-snap-carousel]")?.dataset?.packPerViewMobile;
    const n = Number(raw || 1);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function isMobileCarousel() {
    return window.matchMedia("(max-width: 720px)").matches;
  }

  function bindSnapCarousel(rootEl) {
    const track = rootEl.querySelector("[data-snap-track]") || rootEl.querySelector(".pack-grid, .why__lineup, .how__steps");
    const dotsEl = rootEl.querySelector("[data-snap-dots], [data-pack-dots]");
    if (!track || !dotsEl) return;

    const itemSel = ".pack-card, .why__col, .how__step";
    const cards = [...track.children].filter((el) => el.matches(itemSel));
    const perView = isMobileCarousel() ? mobilePerView(rootEl) : cards.length || 1;

    if (!isMobileCarousel() || cards.length <= 1) {
      dotsEl.innerHTML = "";
      dotsEl.hidden = true;
      return;
    }

    const pageCount = Math.ceil(cards.length / perView);
    dotsEl.hidden = false;
    dotsEl.innerHTML = Array.from({ length: pageCount }, (_, i) => {
      return `<button type="button" class="pack-carousel__dot${i === 0 ? " is-active" : ""}" data-pack-dot="${i}" aria-label="Go to slide ${i + 1}"></button>`;
    }).join("");

    const setActiveDot = (index) => {
      dotsEl.querySelectorAll("[data-pack-dot]").forEach((dot) => {
        const on = Number(dot.dataset.packDot) === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-current", on ? "true" : "false");
      });
    };

    const pageWidth = () => track.clientWidth;

    const onScroll = () => {
      const w = pageWidth();
      if (!w) return;
      const index = Math.round(track.scrollLeft / w);
      setActiveDot(Math.max(0, Math.min(pageCount - 1, index)));
    };

    track.removeEventListener("scroll", track._hdkPackScroll);
    track._hdkPackScroll = onScroll;
    track.addEventListener("scroll", onScroll, { passive: true });

    dotsEl.querySelectorAll("[data-pack-dot]").forEach((dot) => {
      dot.addEventListener("click", () => {
        const index = Number(dot.dataset.packDot) || 0;
        track.scrollTo({ left: index * pageWidth(), behavior: "smooth" });
        setActiveDot(index);
      });
    });

    track.scrollLeft = 0;
    setActiveDot(0);
  }

  function bindPackCarousel(packsEl) {
    const carousel = packsEl.closest("[data-pack-carousel]");
    if (!carousel) return;
    bindSnapCarousel(carousel);
  }

  function bindStaticCarousels() {
    root.querySelectorAll("[data-snap-carousel]").forEach((el) => bindSnapCarousel(el));
  }

  function renderAreaPanel(areaId) {
    const a = CFG.areas[areaId];
    const intro = root.querySelector(`[data-area-intro="${areaId}"]`);
    const packs = root.querySelector(`[data-area-packs="${areaId}"]`);
    if (intro) {
      intro.innerHTML = `<h3 class="area-panel__title">${a.name}</h3><p class="area-panel__blurb">${a.blurb}</p>`;
    }
    if (!packs) return;

    const combos = getAreaCombos(areaId).filter((combo) => {
      return combo.pests.some((p) => CFG.pests[p]);
    });

    packs.innerHTML = combos
      .map((combo) => ({
        kit: buildKit(areaId, combo.pests),
        badge: combo.badge,
        featured: combo.featured,
      }))
      .filter((row) => row.kit)
      .map((row) => cardHtml(row.kit, { badge: row.badge, featured: row.featured }))
      .join("");

    bindPackCarousel(packs);

    const featuredCombo = combos.find((c) => c.featured) || combos[0];
    const featuredKit = featuredCombo ? buildKit(areaId, featuredCombo.pests) : null;
    if (featuredKit) setSticky(featuredKit);
  }

  function setAreaTab(areaId) {
    if (!CFG.areas[areaId]) return;
    activeArea = areaId;
    root.querySelectorAll("[data-area-tab]").forEach((tab) => {
      const on = tab.dataset.areaTab === areaId;
      tab.classList.toggle("is-active", on);
      tab.setAttribute("aria-selected", on ? "true" : "false");
    });
    root.querySelectorAll("[data-area-panel]").forEach((panel) => {
      const on = panel.dataset.areaPanel === areaId;
      panel.classList.toggle("is-active", on);
      panel.hidden = !on;
    });
    renderAreaPanel(areaId);
  }

  function renderPestSection() {
    const pests = [...selectedPests];
    if (pestSummary) {
      const labels = pests.map((k) => CFG.pests[k]?.label).filter(Boolean);
      pestSummary.textContent = labels.length
        ? `Ready-made storefront kits for ${labels.join(" + ")}`
        : "Select at least one pest";
    }
    if (!pestPacksEl) return;
    if (!pests.length) {
      pestPacksEl.innerHTML =
        '<p class="pack-empty">Toggle one or more pests above to see matching kits.</p>';
      return;
    }

    const rows = catalogRowsForPests(pests);
    if (!rows.length) {
      pestPacksEl.innerHTML =
        pests.length < 2
          ? '<p class="pack-empty">Select at least two pests to see a ready-made multi-trap kit.</p>'
          : '<p class="pack-empty">No ready-made kit for that mix in these areas. Try Rats + Mice, or shop by area above.</p>';
      bindPackCarousel(pestPacksEl);
      return;
    }

    pestPacksEl.innerHTML = rows
      .sort(sortKitsBiggestFirst)
      .map((row) => cardHtml(row.kit, { featured: row.featured, badge: row.badge }))
      .join("");
    bindPackCarousel(pestPacksEl);
  }

  function setSticky(kit) {
    lastKit = kit && kit.canAdd ? kit : null;
    const areaLabel = lastKit ? CFG.areas[lastKit.areaId]?.name || "Home" : "Home";
    const pestLabels = lastKit
      ? lastKit.pests.map((k) => CFG.pests[k]?.label).filter(Boolean)
      : [...selectedPests].map((k) => CFG.pests[k]?.label).filter(Boolean);
    const pestLine = pestLabels.length ? pestLabels.join(" + ") : "Rats + Mice";

    if (stickyContext) {
      stickyContext.textContent = `You’re viewing kits for ${pestLine}`;
    }
    if (stickyName) stickyName.textContent = lastKit ? lastKit.name : `${areaLabel} · ${pestLine}`;
    if (stickyPrice) {
      stickyPrice.textContent = lastKit
        ? lastKit.discountRate > 0
          ? `${money(lastKit.price)} · Save ${Math.round(lastKit.discountRate * 100)}%`
          : money(lastKit.price)
        : "";
    }
    if (stickyThumb && lastKit) stickyThumb.src = lastKit.thumb;
    if (stickyBtn) {
      stickyBtn.disabled = !lastKit;
      stickyBtn.textContent = lastKit ? "Add kit to cart" : "Choose a kit";
      if (lastKit) {
        stickyBtn.dataset.kitArea = lastKit.areaId;
        stickyBtn.dataset.kitPests = lastKit.pests.join(",");
      }
    }
    if (builderAtcName) builderAtcName.textContent = lastKit ? lastKit.name : "Choose a kit above";
    if (builderAtcPrice) {
      builderAtcPrice.textContent = lastKit
        ? lastKit.discountRate > 0
          ? `${money(lastKit.price)} · Save ${Math.round(lastKit.discountRate * 100)}%`
          : money(lastKit.price)
        : "";
    }
    if (builderAtcBtn) {
      builderAtcBtn.disabled = !lastKit;
      if (lastKit) {
        builderAtcBtn.dataset.kitArea = lastKit.areaId;
        builderAtcBtn.dataset.kitPests = lastKit.pests.join(",");
        builderAtcBtn.textContent = "Add this kit to cart";
      } else {
        builderAtcBtn.textContent = "Choose a kit";
      }
    }
  }

  function flashToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-on"), 2800);
  }

  async function addKit(areaId, pestList) {
    if (adding) return;
    const kit = buildKit(areaId, pestList);
    if (!kit || !kit.canAdd) {
      flashToast("That kit is unavailable right now");
      return;
    }
    setSticky(kit);
    adding = true;

    const cartDrawer = document.querySelector("cart-drawer");
    const payload = { items: kit.items };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      payload.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      payload.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      let data = await res.json();
      if (data.status) {
        flashToast(data.description || "Could not add to cart");
        return;
      }

      if (kit.discountCode) {
        try {
          await fetch(`/discount/${encodeURIComponent(kit.discountCode)}`, {
            method: "GET",
            credentials: "same-origin",
          });
          const cartRes = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
            credentials: "same-origin",
          });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            data = Object.assign({}, data, cart);
          }
        } catch (discErr) {
          // Kit still added at retail if discount apply fails
        }
      }

      if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
        publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "rr-hdk", cartData: data });
      }
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        if (kit.discountCode && typeof cartDrawer.getSectionsToRender === "function") {
          try {
            const sectionIds = cartDrawer.getSectionsToRender().map((s) => s.id).join(",");
            const secRes = await fetch(
              `${window.location.pathname}?sections=${encodeURIComponent(sectionIds)}`,
              { credentials: "same-origin" }
            );
            if (secRes.ok) {
              const sections = await secRes.json();
              data.sections = sections;
            }
          } catch (secErr) {
            /* fall through with existing data */
          }
        }
        cartDrawer.renderContents(data);
        cartDrawer.open();
      } else {
        window.location.assign(window.routes.cart_url);
        return;
      }
      flashToast(
        kit.discountRate > 0
          ? `Added ${kit.name} · ${Math.round(kit.discountRate * 100)}% kit savings applied`
          : `Added ${kit.name}`
      );
    } catch (err) {
      flashToast("Could not add to cart. Try again.");
    } finally {
      adding = false;
    }
  }

  root.querySelectorAll("[data-area-tab]").forEach((tab) => {
    tab.addEventListener("click", () => setAreaTab(tab.dataset.areaTab));
  });

  root.querySelectorAll("[data-pest-filter]").forEach((chip) => {
    chip.addEventListener("click", () => {
      const key = chip.dataset.pestFilter;
      if (selectedPests.has(key)) selectedPests.delete(key);
      else selectedPests.add(key);
      chip.classList.toggle("is-active", selectedPests.has(key));
      chip.setAttribute("aria-pressed", selectedPests.has(key) ? "true" : "false");
      renderPestSection();
      const rows = catalogRowsForPests([...selectedPests]);
      if (rows[0]?.kit) setSticky(rows[0].kit);
    });
  });

  root.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-add-kit]");
    if (!btn || btn.disabled) return;
    const areaId = btn.dataset.kitArea;
    const pests = (btn.dataset.kitPests || "").split(",").filter(Boolean);
    addKit(areaId, pests);
  });

  root.querySelectorAll("[data-preset]").forEach((el) => {
    el.addEventListener("click", () => {
      const areaKey = el.dataset.presetArea || "home";
      const pests = (el.dataset.presetPests || "rat,mouse").split(",").map((s) => s.trim());
      selectedPests = new Set(pests.filter((p) => CFG.pests[p]));
      root.querySelectorAll("[data-pest-filter]").forEach((chip) => {
        const on = selectedPests.has(chip.dataset.pestFilter);
        chip.classList.toggle("is-active", on);
        chip.setAttribute("aria-pressed", on ? "true" : "false");
      });
      setAreaTab(areaKey);
      renderPestSection();
      const target = el.dataset.presetTarget === "pest" ? "#by-pest" : "#by-area";
      root.querySelector(target)?.scrollIntoView({ behavior: "smooth", block: "start" });
      const combo = findCatalogCombo(areaKey, [...selectedPests]);
      const kit = combo
        ? buildKit(areaKey, combo.pests)
        : catalogRowsForPests([...selectedPests])[0]?.kit || null;
      if (kit) setSticky(kit);
    });
  });

  stickyBtn?.addEventListener("click", () => {
    if (!lastKit) {
      root.querySelector("#kit-builder")?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    addKit(lastKit.areaId, lastKit.pests);
  });

  const onScroll = () => {
    const show = window.scrollY > 480;
    sticky?.classList.toggle("is-on", show);
    sticky?.setAttribute("aria-hidden", show ? "false" : "true");
    root.classList.toggle("has-sticky", show);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  areaKeys().forEach((id) => renderAreaPanel(id));
  setAreaTab("home");
  renderPestSection();
  bindStaticCarousels();
  setSticky(buildKit("home", ["rat", "mouse"]));
  window.addEventListener(
    "resize",
    () => {
      root.querySelectorAll("[data-pack-carousel], [data-snap-carousel]").forEach((el) => bindSnapCarousel(el));
    },
    { passive: true }
  );
})();
